import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class ChatGptUtilitySummaryUpdateService extends BaseService {
  constructor() {
    super(constants.UPDATE_CHATGPT_SUMMARY_DATA, 'ChatGptUtilitySummaryUpdateService');
  }

  handleEvent(eventName, event) {
    const headers = utils.buildHeadersWithTenantId(event);
    return this.getClient('evergreen').post(`/chatutility/updatesummary`, event.payload, { headers });
  }

  handleResponse(response) {
    const { data, status } = response;
    if (status === 200 && data) {
      const notification = {
        open: true,
        type: 'success',
        message: 'Data updated successfully'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('chatgptSummaryUtility').setUpdateResponse();
    } else {
      const notification = {
        open: true,
        type: 'error',
        message: 'Data Not Found'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('chatgptSummaryUtility').resetStoreValues();
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
